import React from "react";
import { StyledStatusLabel } from "../StyledScorebug";
import { useReactAppState } from "../../../containers/utils";
import { statusTypes } from "../../../../mls-match-list/utils";

const STATUS_TYPES = {
  [statusTypes.abandoned]: "match_abandoned",
  [statusTypes.cancelled]: "match_cancelled",
  [statusTypes.delayed]: "match_delayed",
  [statusTypes.postponed]: "match_postponed",
};

function StatusLabel({ status, abbreviateStatus }) {
  const { t } = useReactAppState();

  let key = STATUS_TYPES[status];

  if (abbreviateStatus) {
    key = `${key}.abbr`;
  }

  const label = t(key);

  return (
    <StyledStatusLabel className="mls-c-scorebug__status">
      {abbreviateStatus ? label.toUpperCase() : label}
    </StyledStatusLabel>
  );
}

export default StatusLabel;
